<template>
    <div class="support-widget widget">
        <div class="panel">
            <div class="panel-heading">
                <span class="badge" v-if="unread && unread.count > 0">{{unread.count}}</span>
                <h2>Support Tickets<i class="clippie fa fa-info-circle" v-tooltip="'Your recent support tickets.'"></i></h2>
                <div class="toggle-widget" @click="open=!open">
                    <i v-if="open===true" class="fa fa-minus"></i>
                    <i v-else class="fa fa-plus"></i>
                </div>
            </div>
            <div class="panel-body" v-show="open">
              <VuePerfectScrollbar class="scroll-area" v-once v-if="unread">
                <ul class="unread" v-if="unread.count > 0">
                    <li v-for="message in unread.rows">
                        <router-link :to="{name: 'support', query: {ticket: message.ticketId}}">
                            <p>{{message.body | stripTags | truncate(100)}}</p>
                            <p>{{message.createdAt | shortDate}}</p>
                        </router-link>
                    </li>
                
                </ul>
                <p class="text-center" v-else>No new replies to your tickets</p>

            </VuePerfectScrollbar>
              

            </div>
        </div>
    </div>

</template>

<script>

    import support from '../../services/support';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    export default {
        data() {
            return {
                unread: null,
                open:false
            }
        },
        components: {
            VuePerfectScrollbar
        },
        mounted() {
            var self = this;
            this.getReplies();
            this.$bus.$on('reload', function() {
                self.getReplies();
            });
        },
        methods: {
            getReplies() {
                var self = this;
                support.getUnread(this).then(function(response) {
                    self.unread = response.data.replies;
                });
                // support.getNewestResponse(this).then(function(response) {
                //     self.latestTicket = response.data.reply;
                // });
            }
        }
    }

</script>

<style lang="scss" scoped>

    .scroll-area {
      position: relative;
      margin: auto;
      width: 100%;
      height: 250px;
    }

.support-widget .panel-body {
        padding:0;
    }
    ul {

    }
    li {
        border-bottom: 1px solid #ccc;
        margin-bottom:1rem;
        padding:1rem;

    }
    p {
        margin-top:2rem;
    }

</style>

<style lang="scss">

    .widget .badge {
        background: red;
        position:absolute;
        top:-1rem;
        right:0;
        width:3rem;
        height::3rem;
        line-height: 3rem;
        padding:0;
        border-radius: 50%;
    }
</style>


// WEBPACK FOOTER //
// Support.vue?4dc2d7fd